export const PRODUCT = {
  PORTAL: 'portal',
  PET: 'pet',
} as const

export const PET_TYPE = {
  DOG: 'dog',
} as const
